import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.Line2.placeholder',
        defaultMessage: 'Apt, suite, etc. (optional)',
    },
});

const Line2 = ({
    value,
    autoFocus = false,
    fieldSize,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur = () => {},
}) => {
    const intl = useIntl();
    return (
        <Text
            name="line2"
            dataTn="line-2"
            value={value}
            wrapperClass={styles.group}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="address-line2"
            autoFocus={autoFocus}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

Line2.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};

export default Line2;
